module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-header"
  }, [_c('div', {
    staticClass: "custom-home-header__container"
  }, [_c('HeaderSection', {
    attrs: {
      "content": _vm.props,
      "bodyAlign": "'left'"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "custom-home-header__header",
          domProps: {
            "innerHTML": _vm._s(props.content)
          }
        })
      }
    }, {
      key: "subheader",
      fn: function(props) {
        return _c('div', {
          staticClass: "custom-home-header__subheader",
          domProps: {
            "innerHTML": _vm._s(props.content)
          }
        })
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('div', {
          staticClass: "custom-home-header__body",
          domProps: {
            "innerHTML": _vm._s(props.content)
          }
        })
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0474e3ee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-header/custom-home-header.pug
// module id = 623
// module chunks = 1